import React from 'react';
import { Redirect } from 'react-router-dom';
import ForgetPwdViews from '../views/ForgotPassword';


class ForgetPassword extends React.Component {

	render() {
		const isAlreadyAuthenticated = localStorage.getItem('token');
		return (
      
        <div>
          {isAlreadyAuthenticated ? <Redirect to={{ pathname: '/' }}/> : (
            <ForgetPwdViews />
          )}
        </div>
      
		);
	}
}

export default ForgetPassword;
